
import React from 'react';
import 'stylesheets/ConfirmModal.scss';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Mixpanel } from 'helpers/Mixpanel';
import presenter from '../../duck/presenter';

class DeleteShiftComponent extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  handleCancel = (event) => {
    const { cancelModal } = this.props;
    cancelModal();
    Mixpanel.track('Cancel Delete shift');
  }

  handleConfirm = (event) => {
    const { cancelModal, deleteShiftLocationId, deleteShiftDispatch, deleteShiftId, shouldRevokeChildCard, revokeApprovedChildCardShiftDispatch} = this.props;
    if( shouldRevokeChildCard === false){
      deleteShiftDispatch(deleteShiftId, deleteShiftLocationId);
      Mixpanel.track('Confirm Delete shift', { 'location_id': deleteShiftLocationId, 'shift_id': deleteShiftId });
    }else{
      revokeApprovedChildCardShiftDispatch(deleteShiftId);
      Mixpanel.track('Confirm Revoke Child Card', { 'location_id': deleteShiftLocationId, 'shift_id': deleteShiftId });
    }
    cancelModal();
  }

  render() {
    const { subtype } = this.props;
    
    const cancel = (<FormattedMessage id="Confirm.cancel" defaultMessage="Cancel" />);
    const confirm = (<FormattedMessage id="Confirm.confirm" defaultMessage="Confirm" />);

    return (
      <div className="confirm-modal-container">
        <label className="title averta-regular fs20px">{presenter.deleteTitleText(subtype)}</label>
        <div className='body-text1'>{presenter.deleteBodyText(subtype)}</div>

        <div className="confirm-button-wrap">
          <button className="confirm-button-cancel averta-semibold fs14px" onClick={this.handleCancel}>{cancel}</button>
          <button className="confirm-button averta-semibold fs14px button-enabled" style={{ outline: 0 }} onClick={this.handleConfirm}>{confirm}</button>
        </div>

      </div>
    );
  }
}


export default injectIntl(DeleteShiftComponent);